import React from "react";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { queueService, twilioService } from '../services';
import QueueStatsAll from "../components/Reports/QueueStatsAll";
import QueueStatsUser from "../components/Reports/QueueStatsUser";
import { hasLoaded, getConfig, load as loadConfig } from "../store/slices/configSlice";
import { load as loadBookings } from "../store/slices/bookingSlice";
import { load as loadSalesAreas } from "../store/slices/salesAreaSlice";
import { getAllUsers } from "../store/slices/pipedriveUserSlice";
import { configService } from "../services";
import { InstyleCheckbox } from "../components/Forms/InstyleCheckbox";
import { FormControlLabel } from "@material-ui/core";

export const ReadyToDialPath = "/ready-to-dial";

function ReadyToDial() {
    let dispatch = useDispatch();
    const [resetTwilio, refetchTwilio] = React.useState(1);
    const [workers, setWorkers] = React.useState([]);
    const [selectedWorker, setSelected] = React.useState("all");
    const [selectedQueue, setSelectedQueue] = React.useState();
    const [calls, setCalls] = React.useState([]);

    const [lastUpdate, setLastUpdate] = React.useState(null);
    const [checked, setChecked] = React.useState(false)
    const confighasLoaded = useSelector(hasLoaded)
    const config = useSelector(getConfig)
    const pipedriveUsers = useSelector(getAllUsers)

    //if the config has not been loaded, load it
    useEffect(() => {
        if (!confighasLoaded) {
            configService.getConfig().then((config) => {
                if (config.Success) {
                //set the config to store
                dispatch(loadConfig(config.Data.Config));
                //save booking info
                dispatch(loadBookings(config.Data.BookingInfo));
                //process sales areas and put them in store
                let saData = [];
                Object.keys(config.Data.AvailableSalesAreas).map(k => {
                    saData.push({
                    ID: config.Data.AvailableSalesAreas[k],
                    Label: k
                    });
                });
                dispatch(loadSalesAreas(saData));
                }

            })
        }
    }, [confighasLoaded])

    useEffect(() => {
        fetchAllData();
        const mrTimeout = window.setInterval(fetchAllData, 60000)
        return () => window.clearInterval(mrTimeout)
    }, [])

    const fetchAllData = () => {
        twilioService.getAllUsers().then(resp => {
            let nw = [];
            if (!resp) {
                throw "No Workers Found";
            }
            resp.forEach(worker => {
                if (worker.skills && worker.skills.includes("leadgen")) {
                    nw.push(worker.email)
                }
            })
            nw.sort();
            setWorkers(nw)
        }).then(() => {
            //get all the calls from the server
            queueService.getCallQueue().then((resp) => {
                setCalls(resp.Data.Calls)
            }).then(() => {
                setLastUpdate(new Date());
            })
        })
        .catch(err => {
            console.error(err)
        })
    }

    const toggleOpened = (q) => {
        if (selectedQueue === q) {
            q = "";
        }
        setSelectedQueue(q);
    }

    const queues = ["Fresh Leads", "AC 1", "AC 2", "AC 3", "AC 4", "AC 5", "AC 6", "AC 7", "AC 8"];
    return (
        <Grid container style={{overflow: "scroll"}}>
            <Grid item xs={12} style={{textAlign: "center"}}>
                <h1 style={{fontFamily: "Ink"}}>Available Calls</h1>
            </Grid>
            <Grid item xs={12} style={{textAlign: "center", marginBottom: "15px"}}>
                <FormControlLabel
                    control={<InstyleCheckbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                    label="Show Based on Config"
                />
            </Grid>
            <Grid item xs={12}>
                <Grid container style={{textAlign: "center",flexWrap: "nowrap", paddingBottom: "25px", borderBottom: "1px solid #ccc"}}>
                    <QueueStatsAll config={config} useConfig={checked} queues={queues} calls={calls} />
                </Grid>
                {/* {
                    workers.map((worker, i) => {
                        return (
                            <Grid container style={{textAlign: "center",flexWrap: "nowrap", paddingBottom: "15px", backgroundColor: i % 2 === 0 ? '#FFF' : '#ccc'}}>
                                <QueueStatsUser config={config} useConfig={checked} queues={queues} calls={calls} user={worker} pipedriveUsers={pipedriveUsers} />
                            </Grid>
                        )
                    })
                } */}
            </Grid>
        </Grid>
    )
}

export default ReadyToDial;
